import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from "@mui/material";
import { useEffect, useState } from 'react';
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";
import { getDACCount, getDeviceDACLogsData } from '../../../action/devicelogs';
import { connect } from 'react-redux';
import DeviceDACLogs from './DeviceDACLogs/DeviceDACLogs';
import DACCount from './DACCount/DACCount';

const activeTabSx = { border: '1px solid #bdbdbd', backgroundColor: 'gray', color: '#333333', textTransform: 'capitalize' };
const nonActiveTabSx = { border: 'none', backgroundColor: 'none', color: '#333333', textTransform: 'capitalize' };

const DACStatistics = ({
    wrapperClass,
    dacData,
    getDeviceDACLogsData = () => { },
    getDACCount = () => { }
}) => {

    const [activeTab, setActiveTab] = useState(0)

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            <Box className="row" sx={{ width: "100%", minWidth: 0 }}>
                <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => {
                        setActiveTab(newValue)
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: "#bdbdbd"
                        }
                    }}
                    style={{ marginTop: 0 }}
                >
                    <Tab label="DAC Statistics" sx={activeTab == 0 ? activeTabSx : nonActiveTabSx} />
                    <Tab label="Find Statistics" sx={activeTab == 1 ? activeTabSx : nonActiveTabSx} />
                </Tabs>
                {
                    <div className="container">
                        <div> {(() => {
                            switch (activeTab) {
                                case 0:
                                    return <DACCount
                                        getDACCount={getDACCount}
                                        dacData={dacData} />
                                case 1:
                                    return <DeviceDACLogs
                                        showSearch={true}
                                        showCount={true}
                                        deviceDetails={{}}
                                        dacData={dacData}
                                        getDeviceDACLogsData={getDeviceDACLogsData}
                                    />
                                default:
                                    return null;
                            }
                        })()}
                        </div>
                    </div>
                }
            </Box>
        </ResponsiveContentWrapper>
    );
}

const mapStateToProps = (state) => ({
    dacData: state.report?.deviceLogs,
});

const mapDispatchToProps = (dispatch) => ({
    getDACCount: (params, cb) => dispatch(getDACCount(params, cb)),
    getDeviceDACLogsData: (params, cb) => dispatch(getDeviceDACLogsData(params, cb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DACStatistics);
